import { Center, Image } from "@chakra-ui/react";
import BrandLogo from '../../Assets/Images/VA-WebsiteBrand.png';

const logo = () => {
    return (
        <Center p='5px'>
            <Image src={BrandLogo} maxHeight='70px'/>
        </Center>
    );
};

export default logo;
export const Logo = logo;